import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input',
  imports: [CommonModule, FormsModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputComponent implements OnInit, OnChanges {
  @Input() placeholder: string = '';
  @Input() header: string = '';
  @Input() keyRequired = false;
  @Input() pattern?: string; // optional regex pattern
  @Input() patternMessage?: string; // custom pattern error message
  @Input() id: string = '';
  @Input() checkValidation: boolean = false;
  @Input() readonly: boolean = false;
  @Input() disabled: boolean = false;
  @Input() existingValue: any;
  @Input() type: string = '';
  @Input() icon: boolean | string = false;
  @Input() iconName: string = '';
  @Input() whatIcon: string = '';
  @Input() iconClass: string = '';
  @Input() customClass: string = '';
  @Input() helpText: string = '';

  @Output() selecteditem = new EventEmitter<{ id: string; value: any }>();
  @Output() requiredKey = new EventEmitter<{ id: string; required: boolean }>();

  value: string = '';
  showRequiredError = false;
  showPatternError = false;

  get hasIcon(): boolean {
    const classHasIcon = typeof this.customClass === 'string' &&
      (this.customClass.includes('has-icon') ||
       this.customClass.includes('icon-input') ||
       this.customClass.includes('coupon-input') ||
       this.customClass.includes('coupon-style') ||
       this.customClass.includes('with-icon'));

    return !!(this.icon === true ||
              (typeof this.icon === 'string' && this.icon.trim() !== '' && this.icon !== 'false') ||
              this.effectiveIcon ||
              classHasIcon);
  }

  get effectiveIcon(): string {
    if (typeof this.icon === 'string' && this.icon.trim() !== '' && this.icon !== 'true' && this.icon !== 'false') {
      return this.icon.trim();
    }
    return (this.iconName || this.iconClass || this.whatIcon || '').trim();
  }

  get isFaIcon(): boolean {
    const icon = this.effectiveIcon;
    if (!icon) return false;
    return icon.includes('fa') || icon.startsWith('fa-');
  }

  get resolvedIconClass(): string {
    const icon = this.effectiveIcon;
    if (!icon) return 'fa fa-info-circle';
    if (icon.startsWith('fa-') && !icon.includes(' ')) {
      return `fa ${icon}`;
    }
    return icon;
  }

  get iconText(): string {
    return this.effectiveIcon;
  }

  ngOnInit(): void {
    if (this.keyRequired === true) {
      setTimeout(() => {
        this.requiredKey.emit({ id: this.id, required: this.keyRequired });        
      }, 300);
    }

    // ✅ If existingValue is already present on init
    if (this.existingValue) {
      if (this.existingValue === 'INR') {
        this.existingValue = 'RS'
      }
      this.setAndEmitExistingValue(this.existingValue);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.checkValidation === true && this.value!==null ) {
      this.showRequiredError = true;
    }
    else{
      this.showRequiredError = false
    }

    // ✅ If existingValue changes later
    if (this.existingValue !== null && this.existingValue !== undefined) {
      if (this.existingValue === 'INR') {
        this.existingValue = 'RS'
      }
      this.setAndEmitExistingValue(changes['existingValue'].currentValue);
    }
  }

  private setAndEmitExistingValue(value: string) {
    console.log(value);
    
    this.value = value;
    this.selecteditem.emit({
      id: this.id,
      value: this.value
    });
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input && input.value !== undefined ? input.value : (this.value || '');
    const trimmed = this.value.trim();

    // Required validation
    this.showRequiredError = this.keyRequired && !trimmed;

    // Pattern validation (only if a regex is provided AND value exists)
    if (this.pattern && this.pattern !== '' && trimmed) {
      try {
        const regex = new RegExp(this.pattern);
        this.showPatternError = !regex.test(trimmed);
      } catch {
        this.showPatternError = false;
      }
    } else {
      this.showPatternError = false;
    }

    this.selecteditem.emit({
      id: this.id,
      value: this.value
    });
  }

  onSubmitValue(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement && inputElement.value !== undefined) {
      this.value = inputElement.value;
    }
    const trimmed = (this.value || '').trim();

    // Validation 1: required
    if (this.keyRequired && !trimmed) {
      this.showRequiredError = true;
      this.showPatternError = false;
    } else if (this.pattern && this.pattern !== '' && trimmed) {
      this.showRequiredError = false;
      try {
        const regex = new RegExp(this.pattern);
        this.showPatternError = !regex.test(trimmed);
      } catch {
        this.showPatternError = false;
      }
    } else {
      this.showRequiredError = false;
      this.showPatternError = false;
    }

    // Always emit so parent form receives updated/empty value and recalculates validity
    this.selecteditem.emit({
      id: this.id,
      value: this.value
    });
  }
}
